import SubAppView from './SubAppView';

export default SubAppView;
